import DescriptionPaneEditor from './DescriptionPaneEditor';

export default DescriptionPaneEditor;
export { DescriptionPaneEditor };
